import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSj = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ba0c2f", d: "M0 0h22v16H0z" }), /* @__PURE__ */ React.createElement("g", { fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { d: "M6 0h4v16H6z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 6h22v4H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "#00205b" }, /* @__PURE__ */ React.createElement("path", { d: "M7 0h2v16H7z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 7h22v2H0z" })));
const ForwardRef = forwardRef(SvgSj);
const Memo = memo(ForwardRef);
export default Memo;
